/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Start_LabelInputs */

const en_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start project sync`)
};

const fr_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer la synchronisation du projet`)
};

const de_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektsynchronisierung starten`)
};

const it_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia la sincronizzazione del progetto`)
};

const ru_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать синхронизацию проекта`)
};

const es_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sincronización del proyecto`)
};

const zh_cn2_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始项目同步`)
};

const ja_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの同期を開始`)
};

const hi_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक शुरू करें`)
};

const pt_pt2_team_sync_start_label = /** @type {(inputs: Team_Sync_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sincronização do projeto`)
};

/**
* | output |
* | --- |
* | "Start project sync" |
*
* @param {Team_Sync_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_start_label = /** @type {((inputs?: Team_Sync_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_start_label(inputs)
	if (locale === "de") return de_team_sync_start_label(inputs)
	if (locale === "it") return it_team_sync_start_label(inputs)
	if (locale === "ru") return ru_team_sync_start_label(inputs)
	if (locale === "es") return es_team_sync_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_start_label(inputs)
	if (locale === "ja") return ja_team_sync_start_label(inputs)
	if (locale === "hi") return hi_team_sync_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_start_label(inputs)
	return en_team_sync_start_label(inputs)
});